import React, { useState } from 'react';
import { Search, Trophy } from 'lucide-react';
import { usePoints } from '../../hooks/usePoints';
import { useCustomers } from '../../hooks/useCustomers';
import { useCompanies } from '../../hooks/useCompanies';
import { formatters } from '../../utils/formatters';
import LoadingSpinner from '../common/LoadingSpinner';

const AdminHistory = () => {
  const { pointsHistory, loading: historyLoading } = usePoints();
  const { customers, loading: customersLoading } = useCustomers();
  const { companies, loading: companiesLoading } = useCompanies();
  const [searchTerm, setSearchTerm] = useState('');

  const loading = historyLoading || customersLoading || companiesLoading;

  const filteredHistory = pointsHistory.filter(history => {
    const customer = customers.find(c => c.id === history.customerId);
    const company = companies.find(c => c.id === customer?.companyId);
    
    if (!customer || !company) return false;
    
    if (searchTerm) {
      return customer.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
             customer.cpf.includes(searchTerm) ||
             company.name.toLowerCase().includes(searchTerm.toLowerCase());
    }
    
    return true;
  });

  if (loading) {
    return <LoadingSpinner size="lg" className="py-20" />;
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-800">Histórico Geral de Pontos</h2>
      
      <div className="bg-white rounded-xl p-6 shadow-sm border">
        <div className="flex items-center space-x-4 mb-6">
          <div className="flex-1 relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Buscar por cliente ou empresa..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>
        </div>

        <div className="space-y-4">
          {filteredHistory
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map(history => {
              const customer = customers.find(c => c.id === history.customerId);
              const company = companies.find(c => c.id === customer?.companyId);
              
              return (
                <div key={history.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg border-l-4 border-blue-500">
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <div>
                        <p className="font-medium text-gray-900">{customer?.name}</p>
                        <p className="text-sm text-gray-600">{formatters.formatCpfOrCnpj(customer?.cpf)}</p>
                        <p className="text-xs text-blue-600 font-medium">{company?.name}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-lg font-bold text-green-600">+{history.points} pontos</p>
                        <p className="text-sm text-gray-600">{formatters.formatDate(history.date)}</p>
                      </div>
                    </div>
                    <div className="bg-white p-3 rounded border">
                      <p className="text-sm text-gray-700">
                        <span className="font-medium">Descrição:</span> {history.description}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {formatters.formatDateTime(history.date)}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          
          {filteredHistory.length === 0 && (
            <div className="text-center py-8 text-gray-500">
              <Trophy className="w-12 h-12 text-gray-300 mx-auto mb-4" />
              <p>Nenhum histórico encontrado</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminHistory;